/**
 * @author Красильников Даниил <dkrasilnikov@gmail.com>
 * @link https://t.me/krasilneg
 * 
 * @author Колесник Данил <90.kalias.3@gmail.com>
 * @link https://t.me/kalias_90
 */

import React, { ComponentType, FC, forwardRef, HTMLAttributes, RefObject, PropsWithChildren, ReactNode, useContext, useEffect, useRef } from 'react';
import IntersectionContext from './IntersectionContext';
import { IntersectionListenerHandler } from './IntersectionListener.class';

type IntersecterProps = {
  onIntersect: IntersectionListenerHandler;
  once?: true;
} & PropsWithChildren;

export default function <T extends HTMLAttributes<HTMLElement>>(Component: ComponentType<T> | string) {
  return forwardRef<HTMLElement, T & IntersecterProps>((
    { onIntersect, once, ...props },
    fRef: RefObject<HTMLElement>
  ) => {
    const ref = useRef<HTMLElement>(null);
    const ic = useContext(IntersectionContext);

    useEffect(() => {
      if (ref.current && fRef) {
        fRef.current = ref.current;
      }
    }, [fRef, ref.current]);

    useEffect(() => {
      if (ref.current && ic && onIntersect) {
        ic.listen(ref.current, onIntersect, once);
      }
    }, [ref.current, ic, onIntersect]);

    useEffect(() => {
      return () => {
        if (ic && ref.current) {
          ic.forget(ref.current);
        }
      }
    }, [])

    return <Component ref={ref} {...props as unknown as T} />;
  });
};